import { FONT, MEDIA } from "@/styles/common";
import { Center, Flex, Grid, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { type onNavigateProps } from "@shared/client";
import { useState } from "react";
import { Button as StandardButton } from "../button";
import { CurrentDates, WeekDays } from "./components";
import { useCalendar, useCheckDate } from "./hooks";

export const Calendar = ({ onNavigate }: { onNavigate: ({ path, params }: onNavigateProps) => void }) => {
    const [monthOffset, setMonthOffset] = useState(0);
    const { fullCalendar } = useCalendar({ modeLength: 2, offSet: monthOffset });
    const { checkIn, checkOut, currentObj, maxDate, onChangeColor } = useCheckDate();
    const { isMobile } = MEDIA();

    const onPrevMonth = () => {
        setMonthOffset((prev) => prev - 1);
    };

    const onNextMonth = () => {
        setMonthOffset((prev) => prev + 1);
    };

    return (
        <Center position="relative">
            <Flex
                position="absolute"
                w={isMobile ? "100%" : "720px"}
                top={isMobile ? "auto" : "0"}
                bottom={isMobile ? "-108px" : "auto"}
                pb={isMobile ? "32px" : "auto"}
                justifyContent="space-between"
                columnGap={isMobile ? "8px" : ""}
            >
                <CustomButton onClick={onPrevMonth} disabled={monthOffset <= 0}>
                    PREV
                </CustomButton>
                <CustomButton onClick={onNextMonth}>NEXT</CustomButton>
            </Flex>
            <Grid gridGap="24px" templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}>
                {fullCalendar?.map((cal) => {
                    const { calendar, title } = { ...cal };
                    const { month, year } = { ...title };

                    return (
                        <Flex key={month} flexDir="column" rowGap="24px">
                            <CustomText textAlign="center">
                                {year}년 {month.toString().padStart(2, "0")}월
                            </CustomText>
                            <Flex flexDir="column" rowGap="8px">
                                <WeekDays />
                                <CurrentDates
                                    calendar={calendar}
                                    title={{ year, month }}
                                    checkIn={checkIn}
                                    checkOut={checkOut}
                                    currentObj={currentObj}
                                    maxDate={maxDate}
                                    onChangeColor={onChangeColor}
                                    onNavigate={onNavigate}
                                />
                            </Flex>
                        </Flex>
                    );
                })}
            </Grid>
        </Center>
    );
};

const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 500)}
`;

const CustomButton = styled(StandardButton)`
    background: ${({ disabled }) => (disabled ? ({ theme }) => theme.COLOR.text[200] : "")};

    @media (min-width: ${({ theme }) => theme.MEDIA.mobile}) {
        width: 64px;
        height: 24px;
    }
`;
